import { useState } from "react";

import { Link } from "react-router-dom";

import useWindow from "../hooks/useWindow";
import "./Router.css";

function Router({ pageIndex }) {
    const window = useWindow();

    const [isDropped, setIsDropped] = useState(false);
    const toggleMenu = () => setIsDropped(!isDropped);

    return (
        <div id="router-header-wrapper">
            <nav id="router_header">


                <Link to={'/'} style={{ textDecoration: "none" }}><span id="routerLogo">mReidy</span><span id="routerLogo" style={{ color: "var(--purple-accent)" }}>.</span><span id="routerLogo" style={{ fontSize: "1rem" }}>com</span></Link>

                {window >= 900 ?
                    <>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", width: "fit-content", gap: "20px" }}>
                            <Link className="routerLink" to={'/'}><h4 id="home" className={`${pageIndex === 0 ? "selectedHeaderItem" : "headerItem"}`}>Home</h4></Link>
                            <Link className="routerLink" to={'/about'}><h4 id="about" className={`${pageIndex === 1 ? "selectedHeaderItem" : "headerItem"}`}>About</h4></Link>
                            <Link className="routerLink" to={'/experience'}><h4 id="experience" className={`${pageIndex === 2 ? "selectedHeaderItem" : "headerItem"}`}>Experience</h4></Link>
                            <Link className="routerLink" to={'/projects'}><h4 id="projects" className={`${pageIndex === 3 ? "selectedHeaderItem" : "headerItem"}`}>Projects</h4></Link>
                            <Link className="routerLink" to={'/papers'}><h4 id="paper" className={`${pageIndex === 4 ? "selectedHeaderItem" : "headerItem"}`}>Publications</h4></Link>
                            <Link className="routerLink" to={'/contact'}><h4 id="contact" className={`${pageIndex === 5 ? "selectedHeaderItem" : "headerItem"}`}>Contact&nbsp;Me</h4></Link>

                        </div>

                    </>
                    :
                    <>
                        <ion-icon name="menu-outline" className="menu-icon" onClick={toggleMenu}></ion-icon>
                        {isDropped &&
                            <div className="mobile-menu-dropdown">
                                <Link className="routerLink" to={'/'}><h4 id="home" className={`${pageIndex === 0 ? "selectedHeaderItem" : "headerItem"}`}>Home</h4></Link>
                                <Link className="routerLink" to={'/about'}><h4 id="about" className={`${pageIndex === 1 ? "selectedHeaderItem" : "headerItem"}`}>About Me</h4></Link>
                                <Link className="routerLink" to={'/experience'}><h4 id="experience" className={`${pageIndex === 2 ? "selectedHeaderItem" : "headerItem"}`}>Professional Experience</h4></Link>
                                <Link className="routerLink" to={'/projects'}><h4 id="projects" className={`${pageIndex === 3 ? "selectedHeaderItem" : "headerItem"}`}>Projects</h4></Link>
                                <Link className="routerLink" to={'/papers'}><h4 id="paper" className={`${pageIndex === 4 ? "selectedHeaderItem" : "headerItem"}`}>Papers & Publications</h4></Link>
                                <Link className="routerLink" to={'/contact'}><h4 id="contact" style={{ fontWeight: "bold" }} className={`${pageIndex === 5 ? "selectedHeaderItem" : "headerItem"}`}>Contact Me</h4></Link>
                            </div>
                        }
                    </>
                }

            </nav>
        </div>

    );
}

export default Router;